import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { replaceTemplateKeys } from '@shared/utils/url.lib';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as EntertainmentEventVenuesActions from '../actions/entertainment-event-venues.actions';

@Injectable()
export class EntertainmentEventVenuesEffects {
  constructor(private actions$: Actions, private http: HttpClient) {}

  public indexEntertainmentEventVenues$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EntertainmentEventVenuesActions.GET_ALL_VENUES),
      switchMap((action: EntertainmentEventVenuesActions.GetAllVenues) => {
        const url = replaceTemplateKeys(ApiEndpoint.ENTERTAINMENT_EVENTS_VENUES, { event_id: action.payload });

        return this.http.get(url).pipe(
          map((venues) => new EntertainmentEventVenuesActions.GetAllVenuesSuccess(venues)),
          catchError((error) => of(new EntertainmentEventVenuesActions.GetAllVenuesFail(error)))
        );
      })
    )
  );
}
